module.exports = __webpack_public_path__ + "8134236e3ed7b394918656beaf7744b4.png";


//////////////////
// WEBPACK FOOTER
// ./content/mupit/4igk.png
// module id = 1331
// module chunks = 0